import React from "react";
import Signup from "./Singup";

function Ragister() {
  return (
    <div>
      <Signup />
    </div>
  );
}

export default Ragister;
